<template>
  <v-app id="app">
    <span>
      <v-navigation-drawer
        v-if="true"
        temporary
        v-model="drawer"
        app
        :disable-resize-watcher="true"
      >
        <v-list dense>
          <v-list-tile :to="{name:'Movimentacao'}">
            <v-list-tile-action>
              <v-icon>credit_card</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Movimentação Cartões</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile :to="{name:'Lojas'}">
            <v-list-tile-action>
              <v-icon>map</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Movimentação por Lojas</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile :to="{name:'Recargas'}">
            <v-list-tile-action>
              <v-icon>local_atm</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Recargas por Convênio</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile :to="{name:'Convenio'}">
            <v-list-tile-action>
              <v-icon>card_membership</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Convênios</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile :to="{name:'Promocao'}">
            <v-list-tile-action>
              <v-icon>money_off</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Promoções</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile :to="{name:'Usuarios'}">
            <v-list-tile-action>
              <v-icon>people</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Clientes</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile :to="{name:'Colaboradores'}">
            <v-list-tile-action>
              <v-icon>people</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Colaboradores</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile :to="{name:'Mensagem'}">
            <v-list-tile-action>
              <v-icon>message</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Mensagens</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile :to="{name:'Logout'}">
            <v-list-tile-action>
              <v-icon>exit_to_app</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Sair</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-navigation-drawer>
    </span>

    <v-toolbar
      class="toolbar hidden-xs-and-down"
      v-if="mostrarMenu"
      color="primary"
      dark
      fixed
      app
      height="70"
    >
      <v-toolbar-side-icon v-if="mostraSide" @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title class="black--text">
        <img id="imgTopo" src="@/assets/logoTopo.png" alt="Ommini Pré-Pago" class="mb-5" />
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items color="black" class="pt-4">
        <v-icon color="black" size="25">person</v-icon>
        <span style="color:#000!important">Ola,{{nome}} {{getNome}}</span>
      </v-toolbar-items>

      <v-tabs
        v-show="mostraTabs"
        slot="extension"
        icons-and-text
        centered
        color="primary"
        slider-color="red"
        grow
      >
        <v-tab :to="{name:'Movimentacao'}">
          Movimentação Cartões
          <v-icon color="black lighten-3">credit_card</v-icon>
        </v-tab>

        <v-tab :to="{name:'Recargas'}">
          Recargas por Convênio
          <v-icon color="black lighten-3">local_atm</v-icon>
        </v-tab>

        <v-tab :to="{name:'Lojas'}">
          Movimentação por Lojas
          <v-icon color="black lighten-3">map</v-icon>
        </v-tab>

        <v-tab :to="{name:'Convenio'}">
          Convênios
          <v-icon size="20" color="black lighten-3">card_membership</v-icon>
        </v-tab>

        <v-tab :to="{name:'Promocao'}">
          Promoções
          <v-icon color="black lighten-3">money_off</v-icon>
        </v-tab>
        <!--<v-icon>map</v-icon>-->
        <v-tab v-bind:to="{name:'Mensagem'}">
          Mensagens
          <v-icon color="black lighten-3">message</v-icon>
        </v-tab>
        <!--<v-icon>map</v-icon>-->
        <v-tab v-bind:to="{name:'Usuarios'}">
          Clientes
          <v-icon color="black lighten-1">people</v-icon>
        </v-tab>

        <v-tab v-bind:to="{name:'Colaboradores'}">
          Colaboradores
          <v-icon color="black lighten-1">people</v-icon>
        </v-tab>
        <v-tab v-bind:to="{name:'Logout'}">
          Sair
          <v-icon color="black lighten-3">exit_to_app</v-icon>
        </v-tab>
      </v-tabs>
    </v-toolbar>

    <v-content>
      <router-view></router-view>
    </v-content>
    <v-footer dense color="red" class="pa-2">
      <v-layout>
        <v-flex
          xs12
          py-3
          text-xs-center
          white--text
        >www.grupotecnoweb.com.br&copy; {{ new Date().getFullYear() }}</v-flex>
      </v-layout>
    </v-footer>
  </v-app>
</template>

<script>
import EventBus from "./services/EventBus";
export default {
  name: "app",

  data: () => ({
    drawer: null,
    menu: false,
    nome: window.sessionStorage.getItem("nome"),
    windowHeight: "",
    windowWidth: "",
    mostraSide: false,
    mostraTabs: true
  }),
  created() {
    //this.menu = false;
  },
  mounted() {
    // this.mostrarMenu();
    EventBus.$on("mudounome", () => {
      this.nome = window.sessionStorage.getItem("nome");
    });

    this.$nextTick(() => {
      window.addEventListener("resize", () => {
        this.windowHeight = window.innerHeight;
      });
      window.addEventListener("resize", () => {
        this.windowWidth = window.innerWidth;
      });
    });
  },
  watch: {
    menu() {
      alert(this.menu);
      //this.mostrarMenu();
    },
    windowWidth() {
      if (this.windowWidth < 600) {
        this.mostraTabs = false;
        this.mostraSide = true;
      } else {
        this.mostraSide = false;
        this.mostraTabs = true;
      }
    }
  },

  computed: {
    getNome() {
      setTimeout(() => {
        //return window.sessionStorage.getItem("nome");
      }, 5000);
      setTimeout(() => {
        //alert(window.sessionStorage.getItem("nome"));
        this.nome = window.sessionStorage.getItem("nome");
        //return window.sessionStorage.getItem("nome");
      }, 10000);
    },
    getShow() {
      return window.sessionStorage.getItem("menu");
    },
    mostrarMenu() {
      if (
        this.$route.name == "Login" ||
        this.$route.name == "Index" ||
        this.$route.name == "ResetSenha" ||
        this.$route.name == null
      ) {
        // alert('false')
        return false;
      } else {
        // alert('true')
        return true;
      }
    }
  },
  methods: {
    /*mostrarMenu() {
      console.log("antes: " + window.sessionStorage.getItem("menu"));

      setTimeout(function() {
        if (
          window.sessionStorage.getItem("menu") == "false" ||
          window.sessionStorage.getItem("menu") === false
        ) {
          this.menu = "false";
          //alert("é false");
        } else {
          //alert("é true");
          this.menu = "true";
        }
        console.log("depois: " + window.sessionStorage.getItem("menu"));
      }, 1000);
    }*/
  }
};
</script>

<style >
#imgTopo {
  margin-top: 55px;
}

body {
  margin: 0;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

main {
  text-align: center;
  margin-top: 0px;
}

header {
  margin: 0;
  height: 56px;
  padding: 0 16px 0 24px;
  background-color: #35495e;
  color: #ffffff;
}

header span {
  display: block;
  position: relative;
  font-size: 20px;
  line-height: 1;
  letter-spacing: 0.02em;
  font-weight: 400;
  box-sizing: border-box;
  padding-top: 16px;
}
.v-tabs__container--icons-and-text {
  /*height: 60px!important;*/
}
.toolbar__extension {
  padding: 0 24px 0 24px !important;
}

.v-tabs__item:not(.v-tabs__item--active) {
  opacity: 0.8;
  color: #000 !important;
  font-weight: 100;
}

.v-toolbar__content, .v-toolbar__extension {
    align-items: center;
    display: flex
;
    padding: 0px 5px 5px 5px!important;
}

.v-tabs__div {

font-size:12px!important;
}
.v-tabs__item {
  padding:4px 4px!important;
}  

</style>



// WEBPACK FOOTER //
// src/App.vue